/* eslint-disable */
import React from 'react';
import { Redirect } from 'react-router';
import TwmsMaterial from '../layout/TwmsMaterial';
import Login from '../view/Login/Login';
import Register from '../view/Register';
import UsernameRecovery from '../view/Login/UsernameRecovery/UsernameRecovery';
import ResetPassword from '../view/Login/ResetPassword/ResetPassword';
import Error403 from '../view/Error/error403';
// import Error404 from "../view/Error/error404";
import Error500 from '../view/Error/error500';
import { APP_PATH } from 'config';
var indexRoutes = [
    { path: '/login_intra', component: Login },
    { path: '/login', component: Login },
    { path: '/inv-login', component: Login },
    { path: '/register', component: Register },
    { path: '/usernameRecovery', component: UsernameRecovery },
    { path: '/resetPassword', component: ResetPassword },
    { path: APP_PATH, component: TwmsMaterial },
    { path: '/error403', component: Error403 },
    // { path: "/error404", component: Error404 },
    { path: '/error500', component: Error500 },
    { path: '/', component: function () { return React.createElement(Redirect, { to: "/login" }); } },
];
export default indexRoutes;
